import { Navigate, RouteObject } from "react-router-dom";
import LearningInstitutePage from "../pages/LearningInstitutePage/LearningInstitutePage";
import FirmProfile from "../pages/FirmProfile/FirmProfile";
import UpdatePassword from "../pages/UpdatePassword/UpdatePassword";
import Preview from "../pages/Content/Preview";
import MemberArticlesManage from "../pages/MemberArticles/ManagePage";
import CreatePageArticles from "../pages/MemberArticles/CreatePage";
import AddFirm from "../pages/Catalogs/CRUD/AddFirm";
import Content from "../pages/FirmTools/Content";
import WhatsNew from "../pages/WhatsNew/WhatsNew";
import ProfilePage from "../pages/MyWSG/MyWSG";
import MyEventsPage from "../pages/MyEvents/MyEventsPage";
import TwoFactorAcknowledgement from "../pages/TwoFactorAcknowledgement/TwoFactorAcknowledgement";
import Settings from "../pages/Settings/Settings";
import MembershipDues from "../pages/AboutUs/MembershipDues";
import Bylaws from "../pages/AboutUs/Bylaws";
import WSGMarketingWorkshop from "../pages/WSGLearningInstitute/WSGMarketingWorkshop";
import HelpCenterPage from "../pages/HelpCenter/HelpCenterPage";
import HelpCenterCategoryPage from "../pages/HelpCenter/HelpCenterCategoryPage";
import HelpCenterLegacySubSectionRedirect from "../pages/HelpCenter/HelpCenterLegacySubSectionRedirect";
import { HELP_CENTER_PATH } from "../pages/HelpCenter/helpCenterRoutes";
import MyPreferencesPage from "../pages/MyPreferences/MyPreferencesPage";
import AdvancedMemberSearchPage from "../pages/MemberSearch/AdvancedMemberSearchPage";
import { ADVANCED_MEMBER_SEARCH_PATH } from "../utils/memberSearchNavigation";
import { isNewMemberSearchEnabled } from "../Enums/LegacyRedirection";
import ReferralsList from "../pages/Referrals/ReferralsList";
import ReferralForm from "../pages/Referrals/ReferralForm";
import ReferralDetail from "../pages/Referrals/ReferralDetail";
import { MemberReferralLegacyRedirect } from "../pages/Referrals/ReferralLegacyRedirect";

export const MemberRoutes: RouteObject[] = [
  {
    path: "/mywsg/ID_password/:userId",
    element: <UpdatePassword />,
  },
  {
    path: "/wsg-learning-institute",
    element: <LearningInstitutePage />,
  },
  {
    path: "/profile/idPassword",
    element: <UpdatePassword />,
  },
  {
    path: "/profile/firm/:id",
    element: <FirmProfile />,
  },
  {
    path: "/articles/public",
    element: (
      <Preview
        breadcrumb={{ prevPage: "Articles", currentPage: "Public" }}
        hideModal
      />
    ),
  },
  {
    path: "/articles/manage",
    element: <MemberArticlesManage />,
  },
  {
    path: "/articles/manage/create",
    element: <CreatePageArticles mode="add" />,
  },
  {
    path: "/articles/manage/create/firm",
    element: <AddFirm mode="add" />,
  },
  {
    path: "/articles/manage/preview",
    element: (
      <Preview
        hideModal
        canComment={false}
        showComments
        canEdit={false}
        breadcrumb={{ prevPage: "Edit Content", currentPage: "Preview" }}
      />
    ),
  },
  {
    path: "/publications",
    element: <Content contentType="article" />,
  },
  {
    path: "/presses",
    element: <Content contentType="press" />,
  },
  {
    path: "/publications/view",
    element: (
      <Preview
        hideModal
        canComment={false}
        canEdit={false}
        breadcrumb={{ prevPage: "Firm Tools", currentPage: "Publication" }}
      />
    ),
  },
  {
    path: "/presses/view",
    element: (
      <Preview
        hideModal
        canComment={false}
        canEdit={false}
        breadcrumb={{ prevPage: "Firm Tools", currentPage: "Press" }}
      />
    ),
  },
  {
    path: "/whats-new",
    element: <WhatsNew />,
  },
  {
    path: "mywsg",
    element: <ProfilePage />,
  },
  {
    path: "/referrals",
    element: <ReferralsList variant="member" basePath="/referrals" />,
  },
  {
    path: "/referrals/new",
    element: <ReferralForm variant="member" mode="add" basePath="/referrals" />,
  },
  {
    path: "/referrals/:id/edit",
    element: <ReferralForm variant="member" mode="edit" basePath="/referrals" />,
  },
  {
    path: "/referrals/:id",
    element: <ReferralDetail variant="member" basePath="/referrals" />,
  },
  {
    path: "/manage_referrals.asp",
    element: <MemberReferralLegacyRedirect />,
  },
  {
    path: "mywsg2",
    element: <Navigate to="/mywsg" replace />,
  },
  {
    path: "my-wsg",
    element: <Navigate to="/mywsg" replace />,
  },
  {
    path: "my_wsg",
    element: <Navigate to="/mywsg" replace />,
  },
  {
    path: "/my-events",
    element: <MyEventsPage />,
  },
  {
    path: "/two-factor-acknowledgement",
    element: <TwoFactorAcknowledgement />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/settings/:view",
    element: <Settings />,
  },
  {
    path: "/my-preferences",
    element: <MyPreferencesPage />,
  },
  {
    path: "/bylaws",
    element: <Bylaws />,
  },
  {
    path: "/membership-dues",
    element: <MembershipDues />,
  },
  {
    // Serves the member portal, and the staff portal under `?portal=staff` for staff accounts:
    // React Router matches on the pathname, so the staff portal cannot be its own StaffRoutes
    // entry. Portal-dependent behaviour lives in HelpCenterPage and StaffModeProvider.
    path: HELP_CENTER_PATH,
    element: <HelpCenterPage />,
  },
  {
    path: "/help-center/:audience/:sectionId",
    element: <HelpCenterCategoryPage />,
  },
  {
    path: "/help-center/:audience/:sectionId/:subSectionId",
    element: <HelpCenterLegacySubSectionRedirect />,
  },
  {
    path: "/marketing-workshop-chamber-strategy",
    element: <WSGMarketingWorkshop />,
  },
  ...(isNewMemberSearchEnabled()
    ? [
        {
          path: ADVANCED_MEMBER_SEARCH_PATH,
          element: <AdvancedMemberSearchPage />,
        },
      ]
    : []),
];
